import { createFileRoute } from "@tanstack/react-router";
import LeaderboardsPage from "@/pages/leaderboards/page";

export const Route = createFileRoute("/_pathlessLayout/leaderboards")({
    component: LeaderboardsPage,
});
